<template>
  <div class="main-container">
    <div class="title">{{title}}</div>
    <div class="content" v-html="content"></div>
    <el-divider content-position="left" v-if="files.length > 0">附件</el-divider>
    <div class="attachment" v-if="files.length > 0">
      <el-table :data="files" border style="width: 100%">
        <el-table-column prop="attName" label="文件名称">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" :download="scope.row.attName" :href="baseUrl+scope.row.attPath" target="_blank">{{scope.row.attName}}</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>
<script>
import { allNotice } from '@/api/channel'
import { getNotice } from "api/notice";
export default {
  name: 'Channel',
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      title: null,
      content: '',
      files:[],
    }
  },
  created() {
    this.init();
  },
  watch:{
    $route(to,from){
      let type = to.params.type;
      if(type) {
        this.getNotictByType(type);
      }
    },
  },
  methods: {
    init() {
      let type = this.$route.params.type;
      if(type) {
        this.getNotictByType(type);
      } else {
        let noticeId = this.$route.params.id;
        this.getNotice(noticeId)
      }
    },
    getNotictByType(type) {
      allNotice({noticeType: type}).then(res => {
        if(res.data && res.data.length > 0) {
          this.content = res.data[0].noticeContent
        }
      })
    },
    getNotice(noticeId) {
      getNotice(noticeId).then(res => {
        if(res.data) {
          this.title = res.data.noticeTitle;
          this.content = res.data.noticeContent;
          this.files = res.data.files;
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.main-container {
  .title {
      text-align: center;
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: bold;
  }
  .content {
    /* padding: 50px 45px; */
    color: #333;
    line-height: 30px;
    font-size: 16px;
    p {
      text-align: center;
    }
    ::v-deep {
      table {
        margin: 0 auto;
        border-collapse: collapse;
        >tr {
          td {
            text-align: center;
          }
        }
        td {
          border: 1px solid #ccc;
        }
      }
    }
  }
}
</style>
